import React, { useState, useEffect } from 'react';
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonButton, useIonAlert, IonItem, IonRow, IonCol, IonFooter, IonLabel, IonIcon, IonButtons
} from '@ionic/react';
import {
    actionToGetUserSessionData,
    actionToUploadUserJobProfileData,
    actionToUpdateUserJobProfileData,
    actionToGetAdminJobPostingByFilter, actionToGetUserJobProfileData
} from "../apiHelpers/CommonAction";
import {_getIndianStates} from "../apiHelpers/CommonHelper";
import {arrowBack, star} from "ionicons/icons";
import useStore from "../zustand/useStore";

export default function AddJobCandidateProfileModal({ isOpen, onClose,fromJobList, setIsLoading, fromAdminList, dataForEditing }) {
    const {jobPostingState,userAuthDetail:{userInfo}} = useStore();
    const [candidateErrors, setCandidateErrors] = useState({});
    const [candidateForm, setCandidateForm] = useState({
        name: userInfo?.name,
        email: userInfo?.email,
        phone: userInfo?.phone_number,
        category: '',
        cv: null,
        currentSalary: '',
        expectedSalary: '',
        location: '',
        workType: '',
        experience: '',
    });
    const [presentAlert] = useIonAlert();

    // Prefill form for editing
    useEffect(() => {
        if (dataForEditing?.id) {
            setCandidateForm({
                name: dataForEditing.name || userInfo?.name,
                category: dataForEditing.category || '',
                cv: null, // file input remains empty
                currentSalary: dataForEditing.current_salary || '',
                expectedSalary: dataForEditing.expected_salary || '',
                location: dataForEditing.location || '',
                workType: dataForEditing.work_type || '',
                email: dataForEditing.email || userInfo?.email,
                phone: dataForEditing.phone || userInfo?.phone_number,
                experience: dataForEditing.experience || '',
            });
        }
    }, [dataForEditing]);

    const validateCandidateForm = () => {
        let newErrors = {};

        if (!candidateForm.name.trim()) newErrors.name = "Name is required"; // Added name validation
        if (!candidateForm.category) newErrors.category = "Category is required";

        if (!dataForEditing?.id && !candidateForm.cv) newErrors.cv = "CV PDF is required"; // Only required for add
        else if (candidateForm.cv && candidateForm.cv.type !== "application/pdf") newErrors.cv = "Only PDF files allowed";

        if (!candidateForm.currentSalary.trim()) newErrors.currentSalary = "Current salary or stipend is required";
        if (!candidateForm.expectedSalary.trim()) newErrors.expectedSalary = "Expected salary is required";
        if (!candidateForm.workType) newErrors.workType = "Work preference is required";
        if (!candidateForm.phone) newErrors.phone = "Phone number is required";
        if (!candidateForm.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(candidateForm.email.trim())) {
            newErrors.email = "Invalid email format";
        }

        setCandidateErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCandidateChange = (field, value) => {
        setCandidateForm((prev) => ({ ...prev, [field]: value }));
        setCandidateErrors((prev) => ({ ...prev, [field]: '' }));
    };

    const handleCandidateFileChange = (file) => {
        if (file && file.type === 'application/pdf') {
            setCandidateForm(prev => ({ ...prev, cv: file }));
            setCandidateErrors(prev => ({ ...prev, cv: '' }));
        } else {
            setCandidateForm(prev => ({ ...prev, cv: null }));
            setCandidateErrors(prev => ({ ...prev, cv: 'Only PDF files are allowed.' }));
        }
    };

    const createCandidateFormData = (form) => {
        const formData = new FormData();
        formData.append('name', form.name); // Added name
        formData.append('category', form.category);
        if (form.cv) formData.append('cv', form.cv); // Include CV only if new file selected
        formData.append('current_salary', form.currentSalary);
        formData.append('expected_salary', form.expectedSalary);
        formData.append('location', form.location);
        formData.append('work_type', form.workType);
        formData.append('email', form.email);
        formData.append('phone', form.phone);
        formData.append('experience', form.experience);
        if (dataForEditing?.id) formData.append('id', dataForEditing?.id); // Include ID for edit
        return formData;
    };

    const handleCandidateSubmit = async () => {
        if (!validateCandidateForm()) return;

        const formData = createCandidateFormData(candidateForm);
        setIsLoading(true);

        const apiCall = dataForEditing?.id
            ? actionToUpdateUserJobProfileData(formData) // Edit API
            : actionToUploadUserJobProfileData(formData); // Add API

        apiCall.then(() => {
            setIsLoading(false);
            if(fromJobList){
                actionToGetUserJobProfileData();
            }else if(fromAdminList) {
                presentAlert({
                    message: dataForEditing?.id ? 'Profile updated successfully.' : 'Profile added successfully.',
                    buttons: ['OK']
                });
                actionToGetAdminJobPostingByFilter(false, { offset: jobPostingState?.offset ,user_type:2});
            } else {
                actionToGetUserSessionData();
            }
            onClose();
        }).catch(() => {
            setIsLoading(false);
            presentAlert({
                message: 'Something went wrong while submitting the profile.',
                buttons: ['OK']
            });
        });
    };

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onClose}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="filter_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onClose}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <IonTitle className="filter_sheet_header_text">{dataForEditing?.id ? 'Edit Candidate Profile' : 'Add Candidate Profile'}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding bottom-2 no_padding_top">
                <div className="add-job-content">
                    {/* Candidate Name */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Name<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            className={"rfp_form_input"}
                            placeholder="Enter full name"
                            value={candidateForm.name}
                            onIonInput={(e) => handleCandidateChange('name', e.detail.value)}
                        />
                    </div>
                    {candidateErrors.name && <p className="error-text">{candidateErrors.name}</p>}

                    {/* Candidate Category */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Candidate Category<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonSelect
                            className={"rfp_form_input"}
                            placeholder="Select category"
                            value={candidateForm.category}
                            onIonChange={(e) => handleCandidateChange('category', e.detail.value)}
                        >
                            <IonSelectOption value="CA">CA</IonSelectOption>
                            <IonSelectOption value="CA Articleship">CA Articleship</IonSelectOption>
                            <IonSelectOption value="CA Finalist">CA Finalist</IonSelectOption>
                            <IonSelectOption value="Accountants">Accountants</IonSelectOption>
                            <IonSelectOption value="Other">Other ancillary Professional (CS / LLB / CMA)</IonSelectOption>
                        </IonSelect>
                    </div>
                    {candidateErrors.category && <p className="error-text">{candidateErrors.category}</p>}

                    {/* CV upload */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>CV/Profile (PDF only)<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonItem className={"ion-no-padding ion-margin-bottom"}>
                            <input
                                className={"attach-pdf"}
                                type="file"
                                accept=".pdf"
                                onChange={(e) => handleCandidateFileChange(e.target.files[0])}
                            />
                        </IonItem>
                    </div>
                    {candidateErrors.cv && <p className="error-text">{candidateErrors.cv}</p>}

                    {/* Current Salary */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Current/Last Salary / Stipend<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            className={"rfp_form_input"}
                            placeholder="e.g., 1.5 - 3.5 Lacs P.A / Fresher / NA"
                            value={candidateForm.currentSalary}
                            onIonInput={(e) => handleCandidateChange('currentSalary', e.detail.value)}
                        />
                    </div>
                    {candidateErrors.currentSalary && <p className="error-text">{candidateErrors.currentSalary}</p>}

                    {/* Expected Salary */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Expected Salary/Stipend<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            className={"rfp_form_input"}
                            placeholder="e.g., 2.5 - 5 Lacs P.A / As per employer"
                            value={candidateForm.expectedSalary}
                            onIonInput={(e) => handleCandidateChange('expectedSalary', e.detail.value)}
                        />
                    </div>
                    {candidateErrors.expectedSalary && <p className="error-text">{candidateErrors.expectedSalary}</p>}

                    {/* Location */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Preferred Work Location</IonLabel>
                        <IonSelect
                            className={"rfp_form_input"}
                            placeholder="Select Location"
                            value={candidateForm.location}
                            onIonChange={(e) => handleCandidateChange('location', e.detail.value)}
                        >
                            {_getIndianStates.map((state, index) => (
                                <IonSelectOption key={index} value={state}>{state}</IonSelectOption>
                            ))}
                        </IonSelect>
                    </div>
                    {candidateErrors.location && <p className="error-text">{candidateErrors.location}</p>}

                    {/* Work Preference */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Work Preference<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonSelect
                            className={"rfp_form_input"}
                            placeholder="Select work preference"
                            value={candidateForm.workType}
                            onIonChange={(e) => handleCandidateChange('workType', e.detail.value)}
                        >
                            <IonSelectOption value="Onsite">Onsite</IonSelectOption>
                            <IonSelectOption value="Hybrid">Hybrid</IonSelectOption>
                            <IonSelectOption value="WFH">Work From Home</IonSelectOption>
                        </IonSelect>
                    </div>
                    {candidateErrors.workType && <p className="error-text">{candidateErrors.workType}</p>}

                    {/* Email */}
                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Phone Number<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            className={"rfp_form_input"}
                            placeholder="Enter your phone"
                            type={'tel'}
                            value={candidateForm.phone}
                            onIonInput={(e) => handleCandidateChange('phone', e.detail.value)}
                        />
                    </div>
                    {candidateErrors.phone && <p className="error-text">{candidateErrors.phone}</p>}

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Experience (in years)</IonLabel>
                        <IonInput
                            className={"rfp_form_input"}
                            placeholder="Enter your experience ie (2.6)"
                            type={'number'}
                            value={candidateForm.experience}
                            onIonInput={(e) => handleCandidateChange('experience', e.detail.value)}
                        />
                    </div>

                    <div className={"rfp_submit_form_item"}>
                        <IonLabel>Email ID<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            className={"rfp_form_input"}
                            placeholder="Enter your email"
                            value={candidateForm.email}
                            onIonInput={(e) => handleCandidateChange('email', e.detail.value)}
                        />
                    </div>
                    {candidateErrors.email && <p className="error-text">{candidateErrors.email}</p>}
                </div>
            </IonContent>

            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button" expand="block" onClick={onClose}>Close</IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton className="apply_job_button" onClick={handleCandidateSubmit} expand="block">
                            {dataForEditing?.id ? "Update Profile" : "Submit Profile"}
                        </IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
